module.exports = __webpack_public_path__ + "static/logo-dc5d67e16a84e6dc3e1d1b5f01432c41.png";